export default "__VITE_ASSET__D4FY4XQB__"